
function handleFilters() {
  document.querySelectorAll('filter-buttons').forEach(component => {
    if (component.dataset.dropdownEnabled === 'true') return;

    const options = Array.from(
      component.querySelectorAll('.filter-button')
    );

    if (options.length <= 4) return;

    const moreButton = component.querySelector('.more-filters-button');
    if (!moreButton) return;

    const extraOptions = options.slice(4);

    moreButton.innerText = 'More filters';
    moreButton.classList.remove('hide');

    extraOptions.forEach(option => option.classList.add('hide'));

    moreButton.addEventListener('click', function () {
      const isOpen = this.hasAttribute('open');

      this.toggleAttribute('open', !isOpen);
      this.innerText = isOpen ? 'More filters' : 'Hide filters';

      extraOptions.forEach(option => {
        option.classList.toggle('hide', isOpen);
      });
    });
  });
}

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

document.addEventListener('DOMContentLoaded', handleFilters);


/* ==========================================
   SEARCH FIELD - CANADA ORIGINAL
========================================== */

class SearchField extends HTMLElement {
  constructor() {
    super();
    this.listen();
  }

  listen() {
    const input = this.querySelector('input');
    const mobileButton = this.querySelector('.icon');

    if (!input || !mobileButton) return;

    input.addEventListener('keyup', e => {
      this.search(e.target.value);
    });

    mobileButton.addEventListener('click', () => {
      document.querySelector('filter-buttons')?.removeAttribute('open');
    });

    mobileButton.addEventListener('click', () => {
      this.toggleActive();
    });

    document.addEventListener('click', e => {
      if (!this.contains(e.target) && !input.value) {
        this.removeAttribute('open');
      }
    });
  }

  toggleActive() {
    this.hasAttribute('open')
      ? this.removeAttribute('open')
      : this.setAttribute('open', 'true');
  }

  search(value) {
    value = value.toLowerCase();

    const sections = document.querySelectorAll('.filterable');

    sections.forEach(section => {
      const text = this.getTextContent(section).toLowerCase();

      section.classList.toggle(
        'hide',
        !text.includes(value)
      );
    });
  }

  getTextContent(element) {
    let text = element.textContent;

    if (element.children.length > 0) {
      for (const child of element.children) {
        text += this.getTextContent(child);
      }
    }

    return text;
  }
}

customElements.define('search-field', SearchField);


/* ==========================================
   FILTER BUTTONS - ORIGINAL + DROPDOWN
========================================== */

class FilterButtons extends HTMLElement {
  constructor() {
    super();

    this.sections = document.querySelectorAll('.filterable');
    this.template = document.querySelector('#FilterButtons');

    this.dropdownEnabled =
      this.dataset.dropdownEnabled === 'true';

    this.allTranslation = this.dataset.allLabel || 'All';

    this.dropdownWrapper = null;
    this.dropdownToggle = null;
    this.dropdownMenu = null;
    this.dropdownLabel = null;

    this.render();
  }

  render() {
    if (!this.template) return;

    if (this.dropdownEnabled) {
      this.renderDropdown();
    } else {
      this.renderOriginalButtons();
    }

    const mobileButton = document.querySelector(
      '.filter__heading-mobile'
    );

    mobileButton?.addEventListener('click', () => {
      this.toggleAttribute('open');
    });
  }

  /* ======================================
     ORIGINAL FILTER MODE
  ====================================== */

  renderOriginalButtons() {
    const clone = this.template.content.cloneNode(true);
    const button = clone.querySelector('.filter-button');

    button.classList.add('active');

    const span = document.createElement('span');
    span.textContent = this.allTranslation;
    button.replaceChildren(span);

    button.addEventListener('click', e => this.listen(e));

    this.appendChild(button);

    this.renderButtons(this.sections);
  }

  clearActive() {
    this.querySelectorAll('.filter-button').forEach(button => {
      button.classList.remove('active');
    });
  }

  clearFilters() {
    this.sections.forEach(section => {
      section.classList.remove('hide');
    });
  }

  listen(e) {
    e.preventDefault();

    this.clearActive();

    const button = e.target.closest('.filter-button');
    if (!button) return;

    button.classList.add('active');

    const sectionId = button.getAttribute('section-id');

    if (!sectionId) {
      this.clearFilters();
      return;
    }

    this.sections.forEach(section => {
      section.classList.toggle('hide', section.id !== sectionId);
    });
  }

  listenTags(e) {
    e.preventDefault();

    this.clearActive();

    const button = e.target.closest('.filter-button');
    if (!button) return;

    button.classList.add('active');

    const tagValue = button.getAttribute('tag-value');

    if (!tagValue) {
      this.clearFilters();
      return;
    }

    this.sections.forEach(section => {
      if (!section.dataset.tags) {
        section.classList.add('hide');
        return;
      }

      const cleanTags = section.dataset.tags
        .split(',')
        .map(tag => tag.trim().toLowerCase());

      section.classList.toggle(
        'hide',
        !cleanTags.includes(tagValue)
      );
    });
  }

  renderButtons(sections) {
    const sectionsArray = Array.from(sections);

    const isTagsFilter = sectionsArray.some(
      section => section.dataset.tags !== undefined
    );

    if (isTagsFilter) {
      const tags = [];

      sectionsArray.forEach(section => {
        if (!section.dataset.tags) return;

        tags.push(...section.dataset.tags.split(','));
      });

      const uniqueTags = tags
        .map(tag => tag.toLowerCase().trim())
        .filter(Boolean)
        .filter(onlyUnique);

      uniqueTags.forEach(tag => {
        const clone = this.template.content.cloneNode(true);
        const button = clone.querySelector('.filter-button');

        button.setAttribute('tag-value', tag);

        const span = document.createElement('span');
        span.textContent = tag;
        button.replaceChildren(span);

        button.addEventListener('click', e => this.listenTags(e));

        this.appendChild(button);
      });

    } else {
      sectionsArray.forEach(section => {
        const sectionTitle = section.querySelector('h2')?.innerText;

        if (!sectionTitle) return;

        const clone = this.template.content.cloneNode(true);
        const button = clone.querySelector('.filter-button');

        button.setAttribute('section-id', section.id);

        const span = document.createElement('span');
        span.textContent = sectionTitle;
        button.replaceChildren(span);

        button.addEventListener('click', e => this.listen(e));

        this.appendChild(button);
      });
    }

    const clone = this.template.content.cloneNode(true);
    const moreButton = clone.querySelector('.more-filters-button');

    if (moreButton) {
      this.appendChild(moreButton);
    }
  }

  /* ======================================
     DROPDOWN MODE
  ====================================== */

  getSectionLabel(section) {
    return (
      section.dataset.filterLabel ||
      section.querySelector('h2')?.textContent ||
      ''
    )
      .trim()
      .replace(/:+\s*$/, '');
  }

  getDropdownCategories() {
    const sections = Array.from(this.sections);

    const isTagsFilter = sections.some(
      section => section.dataset.tags !== undefined
    );

    if (isTagsFilter) {
      const tags = [];

      sections.forEach(section => {
        if (!section.dataset.tags) return;

        tags.push(...section.dataset.tags.split(','));
      });

      return tags
        .map(tag => tag.trim().toLowerCase())
        .filter(Boolean)
        .filter(onlyUnique)
        .map(tag => ({
          value: tag,
          label: tag.replace(/:+\s*$/, ''),
          type: 'tag'
        }));
    }

    return sections
      .map((section, index) => {
        if (!section.id) {
          section.id = `filterable-section-${index}`;
        }

        return {
          value: section.id,
          label: this.getSectionLabel(section),
          type: 'section'
        };
      })
      .filter(category => category.label);
  }

  renderDropdown() {
    const wrapper = document.createElement('div');
    wrapper.className = 'filter-dropdown';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'filter-button active filter-dropdown-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-haspopup', 'true');

    const menu = document.createElement('div');
    menu.className = 'filter-dropdown-menu';
    menu.id = `filter-dropdown-menu-${Math.random()
      .toString(36)
      .slice(2, 10)}`;
    menu.setAttribute('role', 'group');
    menu.setAttribute('aria-label', 'Available categories');

    toggle.setAttribute('aria-controls', menu.id);

    const label = document.createElement('span');
    label.className = 'filter-dropdown-label';
    label.textContent = this.allTranslation;

    const caret = document.createElement('span');
    caret.className = 'filter-dropdown-caret';
    caret.setAttribute('aria-hidden', 'true');

    toggle.append(label, caret);
    wrapper.append(toggle, menu);
    this.appendChild(wrapper);

    this.dropdownWrapper = wrapper;
    this.dropdownToggle = toggle;
    this.dropdownMenu = menu;
    this.dropdownLabel = label;

    this.addDropdownOption({
      value: '',
      label: this.allTranslation,
      type: 'all'
    });

    this.getDropdownCategories().forEach(category => {
      this.addDropdownOption(category);
    });

    toggle.addEventListener('click', () => {
      if (wrapper.classList.contains('is-open')) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    });

    this.handleOutsideClick = event => {
      if (!wrapper.contains(event.target)) {
        this.closeDropdown();
      }
    };

    document.addEventListener('click', this.handleOutsideClick);

    wrapper.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.closeDropdown();
        toggle.focus();
      }
    });

    this.updateDropdownSelection('', 'all');
  }

  disconnectedCallback() {
    if (this.handleOutsideClick) {
      document.removeEventListener(
        'click',
        this.handleOutsideClick
      );
    }
  }

  addDropdownOption(category) {
    const option = document.createElement('button');

    option.type = 'button';
    option.className = 'filter-dropdown-option';
    option.textContent = category.label;

    option.dataset.value = category.value;
    option.dataset.type = category.type;
    option.setAttribute('aria-pressed', 'false');

    option.addEventListener('click', () => {
      this.applyDropdownFilter(category);
      this.closeDropdown();
      this.dropdownToggle.focus();
    });

    this.dropdownMenu.appendChild(option);
  }

  openDropdown() {
    this.dropdownWrapper.classList.add('is-open');

    this.dropdownToggle.setAttribute(
      'aria-expanded',
      'true'
    );
  }

  closeDropdown() {
    if (!this.dropdownWrapper) return;

    this.dropdownWrapper.classList.remove('is-open');

    this.dropdownToggle.setAttribute(
      'aria-expanded',
      'false'
    );
  }

  updateDropdownSelection(value, type) {
    const options = Array.from(
      this.dropdownMenu.querySelectorAll('.filter-dropdown-option')
    );

    const selected = options.find(option =>
      option.dataset.value === value &&
      option.dataset.type === type
    );

    this.dropdownLabel.textContent = selected
      ? selected.textContent
      : this.allTranslation;

    options.forEach(option => {
      const isSelected =
        option.dataset.value === value &&
        option.dataset.type === type;

      option.setAttribute('aria-pressed', String(isSelected));
    });
  }

  applyDropdownFilter(category) {
    const { value, type } = category;

    if (type === 'all') {
      this.clearFilters();
      this.updateDropdownSelection('', 'all');
      return;
    }

    if (type === 'section') {
      this.sections.forEach(section => {
        section.classList.toggle(
          'hide',
          section.id !== value
        );
      });
    }

    if (type === 'tag') {
      this.sections.forEach(section => {
        const tags = (section.dataset.tags || '')
          .split(',')
          .map(tag => tag.trim().toLowerCase());

        section.classList.toggle(
          'hide',
          !tags.includes(value)
        );
      });
    }

    this.updateDropdownSelection(value, type);
  }
}

customElements.define('filter-buttons', FilterButtons);
